/** Above this an HTML file downloads instead of rendering; a Plotly export with plotly.js inlined is about 3.6 MB. */
export const HTML_PREVIEW_MAX_BYTES = 5 * 1024 * 1024;

export const HTML_CODE_VIEW_MAX_CHARS = 200_000;

export const HTML_PREVIEW_HEIGHT_PX = 420;
